import React, { useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { IconButton, Toolbar, Drawer, Tooltip } from '@mui/material'
import useLogDrawer from 'activity/hooks/useLogDrawer'
import { ChevronLeft, Launch } from '@mui/icons-material'
import theme from 'styles/theme'
import {
  groupInfoDarkIcon,
} from 'constants/assets'


import VideoPopUp from './VideoPopUp'
import LogForm from './LogForm'

export default function LogDrawer() {
  const { logDrawer, width, closeLogDrawer, state } = useLogDrawer()

  const date = moment(logDrawer?.data?.start_date).format('YYYY-MM-DD')
  const [open, setOpen] = useState(false)
  const [openTooltip, setOpenTooltip] = useState(false)

  let link = null

  if (logDrawer.data?.video) {
    link =  <button type="button"
              style={{ backgroundColor: 'transparent', border: '0px', color: 'teal' }}
              onClick={() => {setOpen(true)}}>{logDrawer.data?.name} <Launch/>
            </button>
  }
  else {
    link =  logDrawer.data?.name
  }

  function closeDrawer() {
    closeLogDrawer()
    setOpen(false)
  }

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  }

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  }

  return (
    <Drawer
      anchor="right"
      open={logDrawer.open}
      onClose={closeDrawer}
      sx={{
        // required for visibility
        zIndex: 1300,
        padding: '1rem'
      }}
      PaperProps={{
        sx: { width: `${width}px` }
      }}
      disableEnforceFocus
    >
      <Drawer.Stylesheet>
        <Toolbar className="toolbar">
          <IconButton edge="start" color="inherit" onClick={closeDrawer}>
            <ChevronLeft sx={{ color: '#fff' }} />
          </IconButton>
          <Drawer.Title>{state.programDialog.data.programName}</Drawer.Title>
        </Toolbar>

        <div className="content">
          <h4>{date}</h4>
          <div style={{display: 'flex'}}>
            <h2>{link}</h2>
            <Tooltip
              title={logDrawer?.data?.exerciseNotes}
              onClose={handleTooltipClose}
              open={openTooltip}
              disableHoverListener
              >
                <button className="exerciseInfo" type="button" onClick={handleTooltipOpen}>
                  {logDrawer?.data?.exerciseNotes?.length > 0 &&
                  (<img src={groupInfoDarkIcon} alt="Info Icon" />)}
                </button>
            </Tooltip>
          </div>
          <LogForm />
        </div>
      </Drawer.Stylesheet>
      <VideoPopUp open={open} onOpenChange={setOpen} video={logDrawer.data?.embed}/>
    </Drawer>
  )
}

Drawer.Stylesheet = styled.div`
  .toolbar {
    background-color: ${theme.palette.secondary.g800};
    color: #fff;
    text-align: center;
    font-weight: 700;
    padding-top: 40px;
    padding-bottom: 16px;
  }

  .content {
    padding: 2rem;

    .fields {
      margin-top: 2rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
  }

  .exerciseInfo {
    border: 0;
    background-color: #fff;
    margin-left: 10px;
    margin-bottom: 5px;
  }
`

Drawer.Title = styled.div`
  text-align: center;
  width: 100%;
  margin-right: 2rem;
`
